module.exports = __webpack_public_path__ + "static/media/22-4.70e23f32.mp3";